import { useEffect, useState } from 'react';
import messages from '../../statics/messages.json';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import * as XLSX from 'xlsx';
import { Modal, Button, Form } from 'react-bootstrap';
import { fetchMeetingHighlight, saveMeetingHighlight } from '../../context/CommonContex';

const Highlights = () => {
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [meetingHighlightData, setMeetingHighlightData] = useState([]);
    const [searchTerm, setSearchTerm] = useState(null);

    const totalPages = Math.ceil(totalRecords / itemsPerPage);
    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages)
            return;
        setCurrentPage(page);
    };


    const getMeetingHighlight = async (index,maxRecords)=>{
        //   if(searchTerm === undefined){
        //         setSearchTerm(null);
        //   }
          var data =  await fetchMeetingHighlight(index,maxRecords,searchTerm);
          if(data){
            setMeetingHighlightData(data.content);
            setTotalRecords(data.totalElements);
          }
        debugger
    }

    useEffect(() => {
        debugger 
        getMeetingHighlight((currentPage - 1) , itemsPerPage);
    }, [currentPage, itemsPerPage,searchTerm]);

    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const [formData, setFormData] = useState({
        attendees: "",
        meetingHightlights: ""
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {

             const comment = await saveMeetingHighlight(formData);
             setCurrentPage(1);
             getMeetingHighlight((currentPage - 1) , itemsPerPage);
             handleClose();
        } catch (error) {
            console.error("Error submitting form:", error);
        }
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    return (
        <div className="box-body border b-white rounded-2">

            <h4 className="p-2 m-0 border-bottom">{messages.production_receiving_label}</h4>

            <div className='row p-2'>
                <div className="col-1 d-flex justify-content-start align-items-bottom">
                    <select
                        className="px-3 py-1 border rounded-1 d-inline"
                        value={itemsPerPage}
                        onChange={(e) => {
                            setItemsPerPage(Number(e.target.value));
                            setCurrentPage(1);
                        }}
                    >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value={totalRecords}>All</option>
                    </select>
                </div>
                <div className="col-7">
                    {/* Toggle buttons for Open, Closed, and All status */}


                </div>
                <div className="col-3">
                    <input
                        type="text"
                        className="form-control"
                        id="search"
                        placeholder={messages.search_label}
                         value={searchTerm}
                         onInput={(e) => setSearchTerm(e.target.value)}
                    /> 
                </div>
                <div className='col-1'>

                    <button className='btn btn-primary w-100' onClick={()=>{handleShow();setFormData({
                                                                                            attendees: "",
                                                                                            meetingHightlights: ""
                                                                                        })}}>Add New</button>
                </div>

               
            </div>
            <div className="row px-2 over-flow-table">

                <div className="col-12 px-2">
                    <div class="" >
                        <table className="table border rounded">
                            <thead class="table-sticky-head">
                                <tr>
                                    <th className="text-center" style={{width:"15%"}}>{messages.cnfrdate_label}</th>
                                    <th className="text-center">{messages.attds_label}</th>
                                    <th className="text-center">{messages.mtng_highlights_label}</th>
                                    <th className="text-center" style={{width:"10%"}}>{messages.action_label}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {meetingHighlightData != undefined && meetingHighlightData.length > 0 ? (
                                    meetingHighlightData.map((line, lineIndex) => {
                                        return (
                                            <tr key={lineIndex}>
                                                <td className='text-center'>{line.createdAt}</td>
                                                <td>{line.attendees}</td>
                                                <td>{line.meetingHightlights}</td>
                                                <td className='text-center'><a onClick={() => { handleShow(); setFormData(line); }}>Edit</a></td>

                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="3" className='text-center'>No data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table></div>

                </div>
                <div className="col-12 py-2">
                    <nav aria-label="Page navigation example">
                        <span>
                            Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, totalRecords)} of {totalRecords}
                        </span>
                        <ul className="pagination float-end">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
                            </li>
                            {[...Array(totalPages)].map((_, index) => (
                                <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                    <button className="page-link" onClick={() => handlePageChange(index + 1)}>{index + 1}</button>
                                </li>
                            ))}
                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group>
                            <Form.Label>{messages.attds_label}</Form.Label>
                            <Form.Control
                                type="text"
                                name="attendees"
                                value={formData.attendees}
                                onChange={handleChange}
                                placeholder="Enter Attendees"
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mt-3">
                            <Form.Label>Meeting Highlights</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={5}
                                style={{resize:"none"}}
                                name="meetingHightlights"
                                value={formData.meetingHightlights}
                                onChange={handleChange}
                                placeholder="Enter Meeting Highlights"
                                required
                            />
                        </Form.Group>

                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Close
                            </Button>
                            <Button variant="primary" type="submit"  onClick={handleSubmit}>
                                Save Changes
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal.Body>
            </Modal>
        </div>

    )
}

export default Highlights;